import qs from "qs"
import type { IGetListParams, IGetListResult } from "../interfaces/get-list.interface"
import axios from "./axios"

const getListItem = async (params: IGetListParams): Promise<IGetListResult> => {

    const { data } = await axios.get('/nft-sales?' + qs.stringify(params))

    const count = data.list?.length || 0

    const result = {
        has_next: count == params.pageSize,
        count: count,
        total: data.total || 0,
        data: data.list || []
    }

    return result
}

export default getListItem